import { createThirdwebClient, defineChain } from "thirdweb";
import { lightTheme } from "thirdweb/react";
import { createWallet, walletConnect as createWalletConnect } from "thirdweb/wallets";
import { chain, thirdweb } from "@/config";

export const client = createThirdwebClient({ clientId: thirdweb.clientId });

export const thirdwebChain = defineChain({
  id: chain.id,
  name: chain.name,
  nativeCurrency: { name: chain.token, symbol: chain.token, decimals: 18 },
  rpc: chain.rpc,
});

export const connectionWallets = [
  createWallet("io.metamask"),
  createWalletConnect(),
  createWallet("com.coinbase.wallet"),
];

export const appTheme = lightTheme({
  fontFamily: "Jost, sans-serif",
  colors: {
    accentButtonBg: "#0055B8",
    accentButtonText: "#fff",
    accentText: "#0055B8",
    primaryButtonBg: "#0055B8",
    primaryButtonText: "#fff",
    connectedButtonBg: "transparent",
    // The details button lives in the dark topbar ($topbar), so the light theme's
    // near-white hover would flash a white block behind the address.
    connectedButtonBgHover: "rgba(255, 255, 255, 0.08)",
  },
});
